export default {

    token: "",
    usuarioDB: []
    
}